import { render } from "./RefundRequestComponent.vue?vue&type=template&id=1036ce25&scoped=true"
import script from "./RefundRequestComponent.vue?vue&type=script&lang=js"
export * from "./RefundRequestComponent.vue?vue&type=script&lang=js"

import "./RefundRequestComponent.vue?vue&type=style&index=0&id=1036ce25&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1036ce25"]])

export default __exports__